import { historyActions } from "./actions";
import { historyState } from "./state";
import { historyGetters } from "./getters";
import { historyMutations } from "./mutations";

const historyModule = {
  namespaced: true,
  actions: historyActions,
  getters: historyGetters,
  mutations: historyMutations,
  state: historyState
};

export { historyModule };
